import React, { Component } from 'react';
import './App.css';
import Header from './components/Header';
import SectionWhatWeDo from './components/SectionWhatWeDo';
import SectionWhoWeAre from './components/SectionWhoWeAre';
import SectionPreviousClients from './components/SectionPreviousClients';
import SectionContactUsForm from './components/SectionContactUsForm';
import Footer from './components/Footer';

import jump from 'jump.js';
import { mainPage } from './data';

import ReactGA from 'react-ga';

class App extends Component {

  constructor() {
    super();
    ReactGA.initialize('UA-93233224-1');
    ReactGA.pageview(window.location.pathname);
  }

  jumpToSection(id) {
    // e.preventDefault();
    jump(id, {
      duration: distance => Math.abs(distance),
      offset: -(document.querySelector('nav').clientHeight / 3),
    });
    if (getComputedStyle(document.querySelector('.toggleNav'), null).display === 'block') {
      // this.toggleMobileNavigationMenu(e);
    }
  }

  // componentDidMount() {
  //
  // }


  render() {
    const {header, whatWeDo, ourTeam, previousClients, contactUs} = mainPage;
    return (
      <div className='App' id='home'>
        <Header headerData={header}/>
        <SectionWhatWeDo whatWeDoData={whatWeDo}/>
        <SectionWhoWeAre ourTeamData={ourTeam}/>
        <SectionPreviousClients previousClientsData={previousClients}/>
        <SectionContactUsForm contactUsData={contactUs}/>
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js